import script from "./Pro_leader.vue?vue&type=script&setup=true&lang=js"
export * from "./Pro_leader.vue?vue&type=script&setup=true&lang=js"

import "./Pro_leader.vue?vue&type=style&index=0&id=0c768ebe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c768ebe"]])

export default __exports__